// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__eoC0B {\n  margin-bottom: 16px; }\n\n.Section_vinWrapper__m-aiU {\n  position: relative; }\n\n.Section_warningModal__3__2e {\n  width: 450px !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__eoC0B",
	"vinWrapper": "Section_vinWrapper__m-aiU",
	"warningModal": "Section_warningModal__3__2e"
};
module.exports = exports;
